// extracted by mini-css-extract-plugin
export var fadeIn = "_8p-0";
export var panelInner = "_8p-2";
export var panelOuter = "_8p-1";